var countries = {
  AB : {
    name: {
      en : "Abkhazia"
    },
    citizenship: true
  },
  AD : {
    capital: "ALV",
    name: {
      en : "Andorra"
    }
  },
  AE : {
    capital: "AUH",
    name: {
      en : "United Arab Emirates"
    },
    citizenship: true
  },
  AF : {
    capital: "KBL",
    name: {
      en : "Afghanistan"
    },
    citizenship: true
  },
  AG : {
    capital: "YYT",
    name: {
      en : "Antigua And Barbuda"
    },
    citizenship: true
  },
  AI : {
    capital: "   ",
    name: {
      en : "Anguilla"
    }
  },
  AK : {
    capital: "SIP",
    name: {
      en : "Republic of Crimea"
    }
  },
  AL : {
    capital: "TIA",
    name: {
      en : "Albania"
    },
    citizenship: true
  },
  AM : {
    capital: "EVN",
    name: {
      en : "Armenia"
    },
    citizenship: true
  },
  AN : {
    capital: "CUR",
    name: {
      en : "Netherland Antilles"
    }
  },
  AO : {
    capital: "LAD",
    name: {
      en : "Angola"
    },
    citizenship: true
  },
  AR : {
    capital: "BUE",
    name: {
      en : "Argen"
    },
    citizenship: true
  },
  AS : {
    capital: "PPG",
    name: {
      en : "Samoa, American"
    }
  },
  AT : {
    capital: "VIE",
    name: {
      en : "Austria"
    },
    citizenship: true
  },
  AU : {
    capital: "CBR",
    name: {
      en : "Australia"
    },
    citizenship: true
  },
  AW : {
    capital: "   ",
    name: {
      en : "Aruba"
    }
  },
  AX : {
    capital: "MHQ",
    name: {
      en : "Aland Islands"
    }
  },
  AZ : {
    capital: "BAK",
    name: {
      en : "Azerbaijan"
    },
    citizenship: true
  },
  BA : {
    capital: "SJJ",
    name: {
      en : "Bosnia Herzegovina"
    },
    citizenship: true
  },
  BB : {
    capital: "BGI",
    name: {
      en : "Barbados"
    }
  },
  BD : {
    capital: "DAC",
    name: {
      en : "Bangladesh"
    },
    citizenship: true
  },
  BE : {
    capital: "BRU",
    name: {
      en : "Belgium"
    },
    citizenship: true
  },
  BF : {
    capital: "OUA",
    name: {
      en : "Burkina Faso"
    },
    citizenship: true
  },
  BG : {
    capital: "SOF",
    name: {
      en : "Bulgaria"
    },
    citizenship: true
  },
  BH : {
    capital: "   ",
    name: {
      en : "Bahrain"
    },
    citizenship: true
  },
  BI : {
    capital: "BJM",
    name: {
      en : "Burundi"
    },
    citizenship: true
  },
  BJ : {
    capital: "COO",
    name: {
      en : "Benin"
    },
    citizenship: true
  },
  BL : {
    name: {
      en : "Saint Barthelemy"
    }
  },
  BM : {
    capital: "BDA",
    name: {
      en : "Bermuda"
    }
  },
  BN : {
    capital: "BWN",
    name: {
      en : "Brunei"
    }
  },
  BO : {
    capital: "LPB",
    name: {
      en : "Bolivia"
    },
    citizenship: true
  },
  BQ : {
    name: {
      en : "Bonaire, Saint Eustatius and Saba"
    }
  },
  BR : {
    capital: "BSB",
    name: {
      en : "Brazil"
    },
    citizenship: true
  },
  BS : {
    capital: "NAS",
    name: {
      en : "Bahamas"
    }
  },
  BT : {
    capital: "   ",
    name: {
      en : "Bhutan"
    }
  },
  BV : {
    capital: "   ",
    name: {
      en : "Bouvet Island"
    }
  },
  BW : {
    capital: "GBE",
    name: {
      en : "Botswana"
    },
    citizenship: true
  },
  BY : {
    capital: "MSQ",
    name: {
      en : "Belarus"
    },
    citizenship: true
  },
  BZ : {
    capital: "   ",
    name: {
      en : "Belize"
    }
  },
  CA : {
    capital: "YOW",
    name: {
      en : "Canada"
    },
    citizenship: true
  },
  CC : {
    capital: "   ",
    name: {
      en : "Cocos Islands"
    }
  },
  CD : {
    capital: "FIH",
    name: {
      en : "Congo Democratic Republic Of"
    },
    citizenship: true
  },
  CF : {
    capital: "BGF",
    name: {
      en : "Central African Republic"
    }
  },
  CG : {
    capital: "BZV",
    name: {
      en : "Congo Republic"
    },
    citizenship: true
  },
  CH : {
    capital: "BRN",
    name: {
      en : "Switzerland"
    },
    citizenship: true
  },
  CI : {
    capital: "ASK",
    name: {
      en : "Cote d'Ivoire"
    },
    citizenship: true
  },
  CK : {
    capital: "   ",
    name: {
      en : "Cook Islands"
    }
  },
  CL : {
    capital: "SCL",
    name: {
      en : "Chile"
    },
    citizenship: true
  },
  CM : {
    capital: "YAO",
    name: {
      en : "Cameroon, United Republic Of"
    },
    citizenship: true
  },
  CN : {
    capital: "BJS",
    name: {
      en : "China"
    },
    citizenship: true
  },
  CO : {
    capital: "BOG",
    name: {
      en : "Colombia"
    },
    citizenship: true
  },
  CR : {
    capital: "SJO",
    name: {
      en : "Costa Rica"
    },
    citizenship: true
  },
  CU : {
    capital: "HAV",
    name: {
      en : "Cuba"
    },
    citizenship: true
  },
  CV : {
    capital: "RAI",
    name: {
      en : "Cape Verde, Republic Of"
    },
    citizenship: true
  },
  CW : {
    name: {
      en : "Curacao"
    }
  },
  CX : {
    capital: "   ",
    name: {
      en : "Christmas Island"
    }
  },
  CY : {
    capital: "NIC",
    name: {
      en : "Cyprus"
    },
    citizenship: true
  },
  CZ : {
    capital: "PRG",
    name: {
      en : "Czech Republic"
    },
    citizenship: true
  },
  DE : {
    capital: "BER",
    name: {
      en : "Germany"
    },
    citizenship: true
  },
  DJ : {
    capital: "JIB",
    name: {
      en : "Djibouti"
    }
  },
  DK : {
    capital: "CPH",
    name: {
      en : "Denmark"
    },
    citizenship: true
  },
  DM : {
    capital: "DCF",
    name: {
      en : "Dominica"
    },
    citizenship: true
  },
  DO : {
    capital: "SDQ",
    name: {
      en : "Dominican Republic"
    },
    citizenship: true
  },
  DZ : {
    capital: "ALG",
    name: {
      en : "Algeria"
    },
    citizenship: true
  },
  EC : {
    capital: "UIO",
    name: {
      en : "Ecuador"
    },
    citizenship: true
  },
  EE : {
    capital: "TLL",
    name: {
      en : "Estonia"
    },
    citizenship: true
  },
  EG : {
    capital: "CAI",
    name: {
      en : "Egypt"
    },
    citizenship: true
  },
  EH : {
    capital: "   ",
    name: {
      en : "Western Sahara"
    }
  },
  ER : {
    capital: "ASM",
    name: {
      en : "Eritrea"
    },
    citizenship: true
  },
  ES : {
    capital: "MAD",
    name: {
      en : "Spain"
    },
    citizenship: true
  },
  ET : {
    capital: "ADD",
    name: {
      en : "Ethiopia"
    },
    citizenship: true
  },
  FI : {
    capital: "HEL",
    name: {
      en : "Finland"
    },
    citizenship: true
  },
  FJ : {
    capital: "SUV",
    name: {
      en : "Fiji Islands"
    },
    citizenship: true
  },
  FK : {
    capital: "PSY",
    name: {
      en : "Falkland Islands"
    }
  },
  FM : {
    capital: "   ",
    name: {
      en : "Micronesia"
    }
  },
  FO : {
    capital: "   ",
    name: {
      en : "Faeroe Islands"
    }
  },
  FR : {
    capital: "PAR",
    name: {
      en : "France"
    },
    citizenship: true
  },
  GA : {
    capital: "LBV",
    name: {
      en : "Gabon"
    },
    citizenship: true
  },
  GB : {
    capital: "LON",
    name: {
      en : "United Kingdom"
    },
    citizenship: true
  },
  GD : {
    capital: "   ",
    name: {
      en : "Grenada"
    },
    citizenship: true
  },
  GE : {
    capital: "TBS",
    name: {
      en : "Georgia"
    },
    citizenship: true
  },
 'GE-AB': {
    name: {
      en : "Abkhazia"
    }
  },
  GF : {
    capital: "CAY",
    name: {
      en : "French Guiana"
    }
  },
  GG : {
    capital: "   ",
    name: {
      en : "Guernsey"
    }
  },
  GH : {
    capital: "ACC",
    name: {
      en : "Ghana"
    },
    citizenship: true
  },
  GI : {
    capital: "GIB",
    name: {
      en : "Gibraltar"
    }
  },
  GL : {
    capital: "GOH",
    name: {
      en : "Greenland"
    }
  },
  GM : {
    capital: "BJL",
    name: {
      en : "Gambia"
    },
    citizenship: true
  },
  GN : {
    capital: "CKY",
    name: {
      en : "Guinea"
    },
    citizenship: true
  },
  GP : {
    capital: "BBR",
    name: {
      en : "Guadeloupe"
    }
  },
  GQ : {
    capital: "SSG",
    name: {
      en : "Equatorial Guinea"
    },
    citizenship: true
  },
  GR : {
    capital: "ATH",
    name: {
      en : "Greece"
    },
    citizenship: true
  },
  GS : {
    capital: "   ",
    name: {
      en : "South Georgia And S Sandwich Island"
    }
  },
  GT : {
    capital: "GUA",
    name: {
      en : "Guatemala"
    },
    citizenship: true
  },
  GU : {
    capital: "   ",
    name: {
      en : "Guam"
    }
  },
  GW : {
    capital: "OXB",
    name: {
      en : "Guinea Bissau"
    },
    citizenship: true
  },
  GY : {
    capital: "   ",
    name: {
      en : "Guyana"
    },
    citizenship: true
  },
  HK : {
    capital: "HKG",
    name: {
      en : "Hong Kong"
    },
    citizenship: true
  },
  HM : {
    capital: "   ",
    name: {
      en : "Heard Island and McDonald Islands"
    }
  },
  HN : {
    capital: "TGU",
    name: {
      en : "Honduras"
    },
    citizenship: true
  },
  HR : {
    capital: "ZAG",
    name: {
      en : "Croatia"
    },
    citizenship: true
  },
  HT : {
    capital: "PAP",
    name: {
      en : "Haiti"
    },
    citizenship: true
  },
  HU : {
    capital: "BUD",
    name: {
      en : "Hungary"
    },
    citizenship: true
  },
  ID : {
    capital: "JKT",
    name: {
      en : "Indonesia"
    },
    citizenship: true
  },
  IE : {
    capital: "DUB",
    name: {
      en : "Ireland, Republic Of"
    },
    citizenship: true
  },
  IL : {
    capital: "TLV",
    name: {
      en : "Israel"
    },
    citizenship: true
  },
  IM : {
    capital: "   ",
    name: {
      en : "Isle Of Man"
    }
  },
  IN : {
    capital: "DEL",
    name: {
      en : "India"
    },
    citizenship: true
  },
  IO : {
    capital: "   ",
    name: {
      en : "British Indian Ocean Territory"
    }
  },
  IQ : {
    capital: "BGW",
    name: {
      en : "Iraq"
    },
    citizenship: true
  },
  IR : {
    capital: "THR",
    name: {
      en : "Iran"
    },
    citizenship: true
  },
  IS : {
    capital: "REK",
    name: {
      en : "Iceland"
    },
    citizenship: true
  },
  IT : {
    capital: "ROM",
    name: {
      en : "Italy"
    },
    citizenship: true
  },
  JE : {
    capital: "   ",
    name: {
      en : "Jersey Island"
    }
  },
  JM : {
    capital: "KIN",
    name: {
      en : "Jamaica"
    },
    citizenship: true
  },
  JO : {
    capital: "AMM",
    name: {
      en : "Jordan"
    },
    citizenship: true
  },
  JP : {
    capital: "TYO",
    name: {
      en : "Japan"
    },
    citizenship: true
  },
  KE : {
    capital: "NBO",
    name: {
      en : "Kenya"
    },
    citizenship: true
  },
  KG : {
    capital: "FRU",
    name: {
      en : "Kyrgyzstan"
    },
    citizenship: true
  },
  KH : {
    capital: "PNH",
    name: {
      en : "Cambodia"
    },
    citizenship: true
  },
  KI : {
    capital: "TRW",
    name: {
      en : "Kiribati"
    }
  },
  KM : {
    capital: "YVA",
    name: {
      en : "Comoros"
    },
    citizenship: true
  },
  KN : {
    capital: "   ",
    name: {
      en : "St. Kitts - Nevis"
    },
    citizenship: true
  },
  KP : {
    capital: "FNJ",
    name: {
      en : "Korea, Democratic Peoples Republic"
    },
    citizenship: true
  },
  KR : {
    capital: "SEL",
    name: {
      en : "Korea, Republic Of"
    },
    citizenship: true
  },
  KV : {
    name: {
      en : "Caucasus"
    }
  },
  KW : {
    capital: "KWI",
    name: {
      en : "Kuwait"
    },
    citizenship: true
  },
  KY : {
    capital: "   ",
    name: {
      en : "Cayman Islands"
    }
  },
  KZ : {
    capital: "TSE",
    name: {
      en : "Kazakhstan"
    },
    citizenship: true
  },
  LA : {
    capital: "   ",
    name: {
      en : "Lao, People's Dem. Rep."
    },
    citizenship: true
  },
  LB : {
    capital: "BEY",
    name: {
      en : "Lebanon"
    },
    citizenship: true
  },
  LC : {
    capital: "   ",
    name: {
      en : "Saint Lucia"
    },
    citizenship: true
  },
  LI : {
    capital: "QVU",
    name: {
      en : "Liechtenstein"
    }
  },
  LK : {
    capital: "CMB",
    name: {
      en : "Sri Lanka"
    },
    citizenship: true
  },
  LR : {
    capital: "MLW",
    name: {
      en : "Liberia"
    },
    citizenship: true
  },
  LS : {
    capital: "MSU",
    name: {
      en : "Lesotho"
    }
  },
  LT : {
    capital: "VNO",
    name: {
      en : "Lithuania"
    },
    citizenship: true
  },
  LU : {
    capital: "LUX",
    name: {
      en : "Luxembourg"
    },
    citizenship: true
  },
  LV : {
    capital: "RIX",
    name: {
      en : "Latvia"
    },
    citizenship: true
  },
  LY : {
    capital: "TIP",
    name: {
      en : "Libyan Arab Jamahiriya"
    },
    citizenship: true
  },
  M1 : {
    popularity: 1,
    name: {
      en : "Mars"
    }
  },
  MA : {
    capital: "RBA",
    name: {
      en : "Morocco"
    },
    citizenship: true
  },
  MC : {
    capital: "   ",
    name: {
      en : "Monaco"
    },
    citizenship: true
  },
  MD : {
    capital: "KIV",
    name: {
      en : "Moldova"
    },
    citizenship: true
  },
  ME : {
    capital: "TGD",
    name: {
      en : "Montenegro"
    },
    citizenship: true
  },
  MF : {
    capital: "SFG",
    name: {
      en : "Saint Martin"
    }
  },
  MG : {
    capital: "   ",
    name: {
      en : "Madagascar (Malagasy)"
    },
    citizenship: true
  },
  MH : {
    capital: "MAJ",
    name: {
      en : "Marshall Islands"
    }
  },
  MK : {
    capital: "SKP",
    name: {
      en : "Macedonia"
    },
    citizenship: true
  },
  ML : {
    capital: "BKO",
    name: {
      en : "Mali"
    },
    citizenship: true
  },
  MM : {
    capital: "RGN",
    name: {
      en : "Myanmar"
    },
    citizenship: true
  },
  MN : {
    capital: "ULN",
    name: {
      en : "Mongolia"
    },
    citizenship: true
  },
  MO : {
    capital: "   ",
    name: {
      en : "Macau"
    },
    citizenship: true
  },
  MP : {
    capital: "SPN",
    name: {
      en : "Marianna Islands"
    }
  },
  MQ : {
    capital: "FDF",
    name: {
      en : "Martinique"
    }
  },
  MR : {
    capital: "NKC",
    name: {
      en : "Mauritania"
    },
    citizenship: true
  },
  MS : {
    capital: "   ",
    name: {
      en : "Montserrat"
    }
  },
  MT : {
    capital: "   ",
    name: {
      en : "Malta"
    },
    citizenship: true
  },
  MU : {
    capital: "   ",
    name: {
      en : "Mauritius"
    },
    citizenship: true
  },
  MV : {
    capital: "MLE",
    name: {
      en : "Maldives"
    },
    citizenship: true
  },
  MW : {
    capital: "LLW",
    name: {
      en : "Malawi"
    },
    citizenship: true
  },
  MX : {
    capital: "MEX",
    name: {
      en : "Mexico"
    },
    citizenship: true
  },
  MY : {
    capital: "KUL",
    name: {
      en : "Malaysia"
    },
    citizenship: true
  },
  MZ : {
    capital: "MPM",
    name: {
      en : "Mozambique"
    },
    citizenship: true
  },
  NA : {
    capital: "WDH",
    name: {
      en : "Namibia"
    },
    citizenship: true
  },
  NC : {
    capital: "   ",
    name: {
      en : "New Caledonia"
    }
  },
  NE : {
    capital: "NIM",
    name: {
      en : "Niger"
    }
  },
  NF : {
    capital: "   ",
    name: {
      en : "Norfolk Island"
    }
  },
  NG : {
    capital: "ABV",
    name: {
      en : "Nigeria"
    },
    citizenship: true
  },
  NI : {
    capital: "MGA",
    name: {
      en : "Nicaragua"
    },
    citizenship: true
  },
  NL : {
    capital: "AMS",
    name: {
      en : "Netherlands"
    },
    citizenship: true
  },
  NO : {
    capital: "OSL",
    name: {
      en : "Norway"
    },
    citizenship: true
  },
  NP : {
    capital: "KTM",
    name: {
      en : "Nepal"
    },
    citizenship: true
  },
  NR : {
    capital: "   ",
    name: {
      en : "Nauru"
    }
  },
  NU : {
    capital: "   ",
    name: {
      en : "Niue"
    }
  },
  NZ : {
    capital: "WLG",
    name: {
      en : "New Zealand"
    },
    citizenship: true
  },
  OM : {
    capital: "MCT",
    name: {
      en : "Oman, Sultanate Of"
    },
    citizenship: true
  },
  ON : {
    popularity: 1,
    name: {
      en : "Moon"
    }
  },
  PA : {
    capital: "PTY",
    name: {
      en : "Panama"
    },
    citizenship: true
  },
  PE : {
    capital: "LIM",
    name: {
      en : "Peru"
    },
    citizenship: true
  },
  PF : {
    capital: "PPT",
    name: {
      en : "French Polynesia"
    }
  },
  PG : {
    capital: "POM",
    name: {
      en : "Papua New Guinea (Niugini)"
    }
  },
  PH : {
    capital: "MNL",
    name: {
      en : "Philippines"
    },
    citizenship: true
  },
  PK : {
    capital: "ISB",
    name: {
      en : "Pakistan"
    },
    citizenship: true
  },
  PL : {
    capital: "WAW",
    name: {
      en : "Poland"
    },
    citizenship: true
  },
  PM : {
    capital: "   ",
    name: {
      en : "St. Pierre and Miquelon"
    }
  },
  PN : {
    capital: "   ",
    name: {
      en : "Pitcairn"
    }
  },
  PR : {
    capital: "SJU",
    name: {
      en : "Puerto Rico"
    },
    citizenship: true
  },
  PS : {
    capital: "JRS",
    name: {
      en : "Occupied Palestinian Territory"
    },
    citizenship: true
  },
  PT : {
    capital: "LIS",
    name: {
      en : "Portugal"
    },
    citizenship: true
  },
  PW : {
    capital: "ROR",
    name: {
      en : "Palau"
    }
  },
  PY : {
    capital: "ASU",
    name: {
      en : "Paraguay"
    },
    citizenship: true
  },
  QA : {
    capital: "DOH",
    name: {
      en : "Qatar"
    },
    citizenship: true
  },
  RE : {
    capital: "   ",
    name: {
      en : "Reunion"
    }
  },
  RO : {
    capital: "BUH",
    name: {
      en : "Romania"
    },
    citizenship: true
  },
  RS : {
    capital: "BEG",
    name: {
      en : "Serbia"
    },
    citizenship: true
  },
  RU : {
    capital: "MOW",
    name: {
      en : "Russia"
    },
    citizenship: true
  },
  RW : {
    capital: "KGL",
    name: {
      en : "Rwanda"
    },
    citizenship: true
  },
  SA : {
    capital: "RUH",
    name: {
      en : "Saudi Arabia"
    },
    citizenship: true
  },
  SB : {
    capital: "HIR",
    name: {
      en : "Solomon Islands"
    }
  },
  SC : {
    capital: "   ",
    name: {
      en : "Seychelles Islands"
    }
  },
  SD : {
    capital: "KRT",
    name: {
      en : "Sudan"
    },
    citizenship: true
  },
  SE : {
    capital: "STO",
    name: {
      en : "Sweden"
    },
    citizenship: true
  },
  SG : {
    capital: "SIN",
    name: {
      en : "Singapore"
    },
    citizenship: true
  },
  SH : {
    capital: "   ",
    name: {
      en : "Ascension Island/St. Helena"
    }
  },
  SI : {
    capital: "LJU",
    name: {
      en : "Slovenia"
    },
    citizenship: true
  },
  SJ : {
    capital: "   ",
    name: {
      en : "Svalbard And Jan Mayen Is"
    }
  },
  SK : {
    capital: "BTS",
    name: {
      en : "Slovakia"
    },
    citizenship: true
  },
  SL : {
    capital: "FNA",
    name: {
      en : "Sierra Leone"
    },
    citizenship: true
  },
  SM : {
    capital: "SAI",
    name: {
      en : "San Marino"
    },
    citizenship: true
  },
  SN : {
    capital: "DKR",
    name: {
      en : "Senegal"
    },
    citizenship: true
  },
  SO : {
    capital: "MGQ",
    name: {
      en : "Somalia"
    }
  },
  SR : {
    capital: "PBM",
    name: {
      en : "Suriname"
    }
  },
  SS : {
    name: {
      en : "South Sudan"
    },
    citizenship: true
  },
  ST : {
    capital: "   ",
    name: {
      en : "Sao Tome and Principe"
    }
  },
  SV : {
    capital: "SAL",
    name: {
      en : "El Salvador"
    },
    citizenship: true
  },
  SX : {
    name: {
      en : "Sint Maarten"
    }
  },
  SY : {
    capital: "DAM",
    name: {
      en : "Syrian Arab Rep."
    },
    citizenship: true
  },
  SZ : {
    capital: "QMN",
    name: {
      en : "Swaziland"
    }
  },
  TC : {
    capital: "   ",
    name: {
      en : "Turks And Caicos Islands"
    }
  },
  TD : {
    capital: "NDJ",
    name: {
      en : "Chad"
    },
    citizenship: true
  },
  TF : {
    capital: "   ",
    name: {
      en : "French Southern Territories"
    }
  },
  TG : {
    capital: "LFW",
    name: {
      en : "Togo"
    },
    citizenship: true
  },
  TH : {
    capital: "BKK",
    name: {
      en : "Thailand"
    },
    citizenship: true
  },
  TJ : {
    capital: "DYU",
    name: {
      en : "Tajikistan"
    },
    citizenship: true
  },
  TK : {
    capital: "   ",
    name: {
      en : "Tokelau"
    }
  },
  TL : {
    capital: "DIL",
    name: {
      en : "Timor Leste"
    }
  },
  TM : {
    capital: "ASB",
    name: {
      en : "Turkmenistan"
    },
    citizenship: true
  },
  TN : {
    capital: "TUN",
    name: {
      en : "Tunisia"
    },
    citizenship: true
  },
  TO : {
    capital: "TBU",
    name: {
      en : "Tonga"
    }
  },
  TR : {
    capital: "ANK",
    name: {
      en : "Turkey"
    },
    citizenship: true
  },
  TT : {
    capital: "POS",
    name: {
      en : "Trinidad and Tobago"
    },
    citizenship: true
  },
  TV : {
    capital: "FUN",
    name: {
      en : "Tuvalu"
    }
  },
  TW : {
    capital: "TPE",
    name: {
      en : "Taiwan, Republic of China"
    },
    citizenship: true
  },
  TZ : {
    capital: "DAR",
    name: {
      en : "Tanzania"
    },
    citizenship: true
  },
  UA : {
    capital: "IEV",
    name: {
      en : "Ukraine"
    },
    citizenship: true
  },
  UG : {
    capital: "KLA",
    name: {
      en : "Uganda"
    },
    citizenship: true
  },
  UM : {
    capital: "   ",
    name: {
      en : "United States Minor Outlying Islands"
    }
  },
  US : {
    capital: "WAS",
    name: {
      en : "United States"
    },
    citizenship: true
  },
  UY : {
    capital: "MVD",
    name: {
      en : "Uruguay"
    },
    citizenship: true
  },
  UZ : {
    capital: "TAS",
    name: {
      en : "Uzbekistan"
    },
    citizenship: true
  },
  VA : {
    capital: "   ",
    name: {
      en : "Vatican City State"
    }
  },
  VC : {
    capital: "   ",
    name: {
      en : "Saint Vincent And The Grenadines"
    },
    citizenship: true
  },
  VE : {
    capital: "CCS",
    name: {
      en : "Venezuela"
    },
    citizenship: true
  },
  VG : {
    capital: "   ",
    name: {
      en : "British Virgin Islands"
    }
  },
  VI : {
    name: {
      en : "Virgin Islands U.S."
    }
  },
  VN : {
    capital: "HAN",
    name: {
      en : "Vietnam"
    },
    citizenship: true
  },
  VU : {
    capital: "VLI",
    name: {
      en : "Vanuatu"
    },
    citizenship: true
  },
  WF : {
    capital: "   ",
    name: {
      en : "Wallis and Futuna Islands"
    }
  },
  WS : {
    capital: "APW",
    name: {
      en : "Samoa, Independent State Of"
    }
  },
  XK : {
    capital: "PRN",
    name: {
      en : "Kosovo"
    },
    citizenship: true
  },
  YE : {
    capital: "SAH",
    name: {
      en : "Yemen, Republic Of"
    },
    citizenship: true
  },
  YT : {
    capital: "   ",
    name: {
      en : "Mayotte"
    }
  },
  ZA : {
    capital: "PRY",
    name: {
      en : "South Africa Republic"
    },
    citizenship: true
  },
  ZM : {
    capital: "LUN",
    name: {
      en : "Zambia"
    },
    citizenship: true
  },
  ZW : {
    capital: "HRE",
    name: {
      en : "Zimbabwe"
    },
    citizenship: true
  }
};

global.___countries = countries;
var lang = "ru";
if (typeof window !== "undefined") {
 switch (self.document.documentElement.lang) {
     case "uk-ua":
       lang = "ua";
       break;
     case "ru-ua":
       lang = "ru";
       break;
     default:
       lang = self.document.documentElement.lang.substring(0, 2);
       break;
 }
}
const defineProps = function(obj) {
  var keys = Object.keys(obj);
  var key;
  var val;
  var type;
  var k = keys.length;
  while (k--) {
    key = keys[k];
    val = obj[key];
    val.$code = key 
    val.$type = "countries"
    type = typeof val;
    if (type === "object") {
      if (val[lang]) {
        Object.defineProperty(obj, key, {
          value: val[lang]
        });
        Object.defineProperty(obj, key+"En", {
          value: val.en,
          enumerable: true
        });
      } else {
        defineProps(val);
      }
    }
  }
};
typeof window !== "undefined" && defineProps(countries);
module.exports = countries;
